import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react';
import {Configuration} from '../configuration';
import {createBaseQueryArgs} from './api/createBaseQueryArgs';

export const defaultOptions = {
  endpoints: () => ({}),
  tagTypes: [
    'UserPreference',
    'Work',
    'Series',
    'FilterSet',
    'ColumnSet',
    'Media',
    'Agent',
    'Prize',
    'Notes',
    'MergeSuggestions',
  ],
  // Keep a low cache by default. Cached enpoints are overridden when needed.
  // E.g. thesaurus and codelist
  keepUnusedDataFor: 5,
};

export const ebsBaseQuery = retry(
  fetchBaseQuery(createBaseQueryArgs(Configuration.api.baseUri)),
  {maxRetries: 0},
);

export const ebsApi = createApi({
  ...defaultOptions,
  reducerPath: 'ebsApi',
  baseQuery: ebsBaseQuery,
});
